import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CheckCircle2, XCircle, RefreshCw, Send } from "lucide-react";
import { toast } from "sonner";

const Row = ({ label, part, testid }) => (
  <div className={`rounded-xl border p-3 flex items-center gap-3 ${part?.ok ? "bg-emerald-50 border-emerald-200" : "bg-red-50 border-red-200"}`} data-testid={testid}>
    {part?.ok ? <CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0" /> : <XCircle className="w-5 h-5 text-red-600 shrink-0" />}
    <div className="min-w-0">
      <div className="font-semibold text-sm">{label} · {part?.host}:{part?.port} (SSL)</div>
      <div className="text-xs text-muted-foreground break-all">
        {part?.ok ? (part.messages !== undefined ? `Verbunden · ${part.messages} Mails im Posteingang, ${part.unseen} ungelesen` : "Verbunden") : (part?.error || "Nicht verbunden")}
      </div>
    </div>
  </div>
);

export const MailSettingsCard = () => {
  const [st, setSt] = useState(null);
  const [loading, setLoading] = useState(false);
  const [to, setTo] = useState("");
  const [sending, setSending] = useState(false);

  const load = async () => {
    setLoading(true);
    try { setSt((await api.get("/mail/status")).data); }
    catch (e) { toast.error(e.response?.data?.detail || "Status konnte nicht geladen werden"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const sendTest = async () => {
    setSending(true);
    try {
      await api.post("/mail/test", { to });
      toast.success(`Test-Mail an ${to} verschickt – Kopie liegt im Ordner „Gesendet".`);
    } catch (e) { toast.error(e.response?.data?.detail || "Versand fehlgeschlagen"); }
    finally { setSending(false); }
  };

  return (
    <div className="msb-card" data-testid="mail-settings-card">
      <div className="flex items-center gap-3 mb-3">
        <h2 className="text-xl font-bold flex-1" style={{ fontFamily: "'Work Sans',sans-serif" }}>E-Mail-Postfach (Strato)</h2>
        <Button variant="outline" size="sm" onClick={load} disabled={loading} data-testid="mail-status-refresh-btn">
          <RefreshCw className={`w-4 h-4 mr-1 ${loading ? "animate-spin" : ""}`} /> Prüfen
        </Button>
      </div>
      {st && (
        <div className="space-y-2">
          <div className="text-sm" data-testid="mail-sender">Absender aller Portal-Mails: <strong>{st.from_name} &lt;{st.address}&gt;</strong></div>
          <div className="grid md:grid-cols-2 gap-2">
            <Row label="Empfang (IMAP)" part={st.imap} testid="mail-imap-status" />
            <Row label="Versand (SMTP)" part={st.smtp} testid="mail-smtp-status" />
          </div>
        </div>
      )}
      <div className="flex flex-wrap gap-2 mt-4 items-center">
        <Input type="email" placeholder="Empfänger für Test-Mail" value={to} onChange={(e) => setTo(e.target.value)} className="max-w-xs" data-testid="mail-test-to-input" />
        <Button onClick={sendTest} disabled={sending || !to} data-testid="mail-test-send-btn">
          <Send className="w-4 h-4 mr-1" /> {sending ? "Sende…" : "Test-Mail senden"}
        </Button>
      </div>
    </div>
  );
};
